import { StandardEvents } from '@shopify/events';

const configuration = document.querySelector('[data-tbx-config]');
if (configuration) {
  const config = JSON.parse(configuration.textContent);
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(value);
  const cleanHandles = values => Array.isArray(values) ? [...new Set(values.filter(validHandle))].slice(0, 20) : [];
  const read = key => {
    try { return cleanHandles(JSON.parse(localStorage.getItem(key) || '[]')); }
    catch { return []; }
  };
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch { return false; }
  };
  const customer = config.customer ? String(config.customer) : null;
  const savedKey = customer ? `tearblends:saved:v1:${customer}` : null;
  const recentKey = 'tearblends:recent:v1';
  const pendingKey = 'tearblends:pending-save:v1';
  let saved = savedKey ? read(savedKey) : [];
  let savedRender = 0;
  const cards = new Map();
  const status = message => {
    const node = document.querySelector('[data-tbx-status]');
    if (node) node.textContent = message;
  };
  const updateButtons = () => {
    document.querySelectorAll('[data-tbx-save]').forEach(button => {
      const active = saved.includes(button.dataset.tbxSave);
      button.setAttribute('aria-pressed', String(active));
      const label = active ? config.labels.unsave : config.labels.save;
      button.title = label;
      button.setAttribute('aria-label', `${label}: ${button.dataset.tbxTitle || ''}`);
    });
    document.querySelectorAll('[data-tbx-saved-count]').forEach(node => {
      if (node.textContent !== String(saved.length)) node.textContent = String(saved.length);
    });
  };
  const productCard = async handle => {
    if (!validHandle(handle)) return null;
    if (!cards.has(handle)) {
      const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
      const url = new URL(`${root}products/${handle}`, window.location.origin);
      url.searchParams.set('section_id', 'tb-b2b-discovery-card');
      cards.set(handle, fetch(url.href, { credentials: 'same-origin' })
        .then(response => response.ok ? response.text() : '')
        .then(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const card = parsed.querySelector('[data-tbx-card]');
          if (!card || card.dataset.tbxHandle !== handle) return null;
          card.querySelectorAll('script, iframe, object, embed').forEach(node => node.remove());
          return card;
        })
        .catch(() => null));
    }
    const card = await cards.get(handle);
    return card ? card.cloneNode(true) : null;
  };
  const loadCards = async handles => {
    const results = new Array(handles.length);
    let index = 0;
    await Promise.all(Array.from({ length: Math.min(3, handles.length) }, async () => {
      while (index < handles.length) {
        const position = index++;
        results[position] = await productCard(handles[position]);
      }
    }));
    return results.filter(Boolean);
  };
  const updateScrollButtons = section => {
    const track = section.querySelector('[data-tbx-track]');
    if (!track) return;
    const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    section.querySelectorAll('[data-tbx-scroll]').forEach(button => {
      button.disabled = Number(button.dataset.tbxScroll) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= maximum - 2;
    });
  };
  const bindTrack = section => {
    const track = section.querySelector('[data-tbx-track]');
    if (!track || track.dataset.tbxBound) return;
    track.dataset.tbxBound = 'true';
    track.addEventListener('scroll', () => updateScrollButtons(section), { passive: true });
    new ResizeObserver(() => updateScrollButtons(section)).observe(track);
    updateScrollButtons(section);
  };
  const renderSaved = async () => {
    const dialog = document.querySelector('[data-tbx-saved-dialog]');
    if (!dialog || !dialog.open) return;
    const generation = ++savedRender;
    const grid = dialog.querySelector('[data-tbx-saved-grid]');
    const empty = dialog.querySelector('[data-tbx-saved-empty]');
    const availableCards = await loadCards(saved);
    if (generation !== savedRender || !dialog.open) return;
    grid.replaceChildren(...availableCards);
    empty.hidden = availableCards.length > 0;
    empty.textContent = saved.length ? config.labels.unavailable : config.labels.empty;
    updateButtons();
  };
  const toggleSaved = handle => {
    if (!savedKey || !validHandle(handle)) return;
    const wasSaved = saved.includes(handle);
    const next = wasSaved ? saved.filter(item => item !== handle) : [handle, ...saved].slice(0, 20);
    if (!write(savedKey, next)) { status(config.labels.storageError); return; }
    saved = next;
    updateButtons();
    status(wasSaved ? config.labels.removed : config.labels.saved);
    renderSaved();
  };
  if (customer) {
    try {
      const pending = sessionStorage.getItem(pendingKey);
      if (validHandle(pending) && !saved.includes(pending)) {
        const next = [pending, ...saved].slice(0, 20);
        if (write(savedKey, next)) { saved = next; sessionStorage.removeItem(pendingKey); }
        else status(config.labels.storageError);
      } else sessionStorage.removeItem(pendingKey);
    } catch {}
  }
  document.addEventListener('click', event => {
    const login = event.target.closest('[data-tbx-login-save]');
    if (login) {
      try { sessionStorage.setItem(pendingKey, login.dataset.tbxLoginSave); } catch {}
      return;
    }
    const save = event.target.closest('[data-tbx-save]');
    if (save) { event.preventDefault(); toggleSaved(save.dataset.tbxSave); return; }
    const dialog = document.querySelector('[data-tbx-saved-dialog]');
    if (event.target.closest('[data-tbx-open-saved]') && dialog) {
      dialog.showModal();
      dialog.querySelector('[data-tbx-saved-grid]').replaceChildren();
      const empty = dialog.querySelector('[data-tbx-saved-empty]');
      empty.hidden = false;
      empty.textContent = saved.length ? config.labels.loading : config.labels.empty;
      renderSaved();
    }
    if (event.target.closest('[data-tbx-close-saved]') && dialog) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
    const scroll = event.target.closest('[data-tbx-scroll]');
    if (scroll) {
      const track = scroll.closest('.tbx-section')?.querySelector('[data-tbx-track]');
      if (track) track.scrollBy({ left: Number(scroll.dataset.tbxScroll) * (track.clientWidth + 24), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
  window.addEventListener('storage', event => {
    if (savedKey && event.key === savedKey) { saved = read(savedKey); updateButtons(); renderSaved(); }
  });
  document.addEventListener(StandardEvents.productSelect, async event => {
    try { await event.promise; } catch {}
    updateButtons();
  });
  document.addEventListener('shopify:section:load', () => {
    updateButtons();
    document.querySelectorAll('.tbx-section').forEach(bindTrack);
  });
  updateButtons();
  document.querySelectorAll('.tbx-section').forEach(bindTrack);
  const previous = read(recentKey).filter(handle => handle !== config.handle).slice(0, 8);
  write(recentKey, [config.handle, ...previous].filter(validHandle).slice(0, 12));
  const recent = document.querySelector('[data-tbx-recent]');
  if (recent && previous.length) {
    const loadRecent = async () => {
      const availableCards = await loadCards(previous);
      if (!availableCards.length) return;
      recent.querySelector('[data-tbx-track]').replaceChildren(...availableCards);
      recent.querySelector('[data-tbx-preview-note]')?.remove();
      recent.hidden = false;
      bindTrack(recent);
      updateScrollButtons(recent);
      updateButtons();
    };
    loadRecent();
  }
  const related = document.querySelector('[data-tbx-related]');
  if (related) {
    const loadRelated = async () => {
      try {
        const response = await fetch(related.dataset.tbxRecommendationsUrl, { credentials: 'same-origin' });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = parsed.querySelector('[data-tbx-related] [data-tbx-track]');
        const track = related.querySelector('[data-tbx-track]');
        if (!incoming || !incoming.querySelector('[data-tbx-card]')) return;
        if (incoming.querySelectorAll('[data-tbx-card]').length < track.querySelectorAll('[data-tbx-card]').length) return;
        track.replaceChildren(...Array.from(incoming.children));
        related.hidden = false;
        bindTrack(related);
        updateScrollButtons(related);
        updateButtons();
      } catch {}
    };
    if ('IntersectionObserver' in window && !related.hidden) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); loadRelated(); }
      }, { rootMargin: '250px' });
      observer.observe(related);
    } else loadRelated();
  }
}
